import { render, staticRenderFns } from "./ParentAndStudentCreate.vue?vue&type=template&id=a727df00"
import script from "@/controllers/custom/parent/parent-and-student-create.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/parent/parent-and-student-create.js?vue&type=script&lang=js&external"
import style0 from "./ParentAndStudentCreate.vue?vue&type=style&index=0&id=a727df00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports